import React from 'react';

const RothConversionBeneNote = () => {
  return (
    <section className="roth-conv-div">
      <h3>Important Note</h3>
      <div>
        Beneficiary designations must be identical for all identically
        registered accounts.
      </div>
      <div>
        If a primary beneficiary dies before you, the percentages will be
        recalculated proportionately among the surviving primary beneficiaries
        unless other instructions are provided. Similar rules apply to secondary
        beneficiaries. Secondary beneficiaries inherit assets only if no primary
        beneficiaries survive you.
      </div>
      <div>
        For IRAs only, if there are no beneficiaries on your account, your
        surviving spouse (who must be your spouse under federal law) will be
        considered your sole beneficiary. If you do not have a surviving spouse,
        your estate will be considered your sole beneficiary.
      </div>
      <div>
        You may wish to speak to an estate planner or your legal or tax
        professional about your personal situation.
      </div>
    </section>
  );
};

export default RothConversionBeneNote;
